"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAgendaSlotsAvailableListApiResponseSchema = void 0;
const zod_1 = require("zod");
const paginate_list_api_response_schema_1 = require("../global/paginate-list-api-response.schema");
const agenda_slot_1 = require("./agenda-slot");
const agenda_slot_reservation_1 = require("./agenda-slot-reservation");
exports.getAgendaSlotsAvailableListApiResponseSchema = (0, paginate_list_api_response_schema_1.paginteListApiResponseSchema)(agenda_slot_1.getAgendaSlotItemApiSchema).merge(zod_1.z.object({
    included: zod_1.z
        .array(zod_1.z.union([
        agenda_slot_1.agendaSlotDoctorAttendingSchema,
        agenda_slot_reservation_1.agendaSlotReservationApiSchema,
        agenda_slot_reservation_1.slotReservationDoctorSubstituteSchema,
    ]))
        .optional()
        .default([]),
}));
